import consts from "@/common/consts";

export const types = {
	"SET_ACTIVE_TAB": "SET_ACTIVE_TAB",
	"SET_NOTIFICATION": "SET_NOTIFICATION",
	"CLEAR_NOTIFICATION": "CLEAR_NOTIFICATION",
	"SET_WIDGET_LOADED": "SET_WIDGET_LOADED",
};

/* initial state */
const state = {
	activeTab: consts.TABS.PREVIEW,
	notificationType: null,
	notificationText: null,
	widgetLoaded: false,
};

const getters = {};

const actions = {
	[types.SET_ACTIVE_TAB]({commit}, tab){
		commit(types.SET_ACTIVE_TAB, {tab});
	},

	[types.SET_NOTIFICATION]({commit}, payload){
		commit(types.SET_NOTIFICATION, payload);
	},

	[types.CLEAR_NOTIFICATION]({commit}){
		commit(types.CLEAR_NOTIFICATION);
	},

	[types.SET_WIDGET_LOADED]({commit}) {
		commit(types.SET_WIDGET_LOADED);
	},
};

const mutations = {
	[types.SET_ACTIVE_TAB](state, {tab}) {
		state.activeTab = tab;
	},

	[types.SET_NOTIFICATION](state, payload){
		state.notificationType = payload.type;
		state.notificationText = payload.text;
	},

	[types.CLEAR_NOTIFICATION](state){
		state.notificationType = null;
		state.notificationText = null;
	},

	[types.SET_WIDGET_LOADED](state) {
		state.widgetLoaded = true;
	},

};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
